webpackJsonp([183400410456155],{

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _utils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	  var posts = data.posts.edges; // data.markdownRemark holds our post data
	
	  var allPostTags = data.tags;
	
	  var tags = [];
	
	  var getAllTags = function getAllTags(allPosts) {
	    allPosts.edges.forEach(function (_ref2) {
	      var post = _ref2.node;
	
	      post.frontmatter.tags.forEach(function (tag) {
	        if (post.frontmatter.unpublished) return;
	        if (!tags.includes(tag)) {
	          tags.push(tag);
	        }
	      });
	    });
	  };
	
	  getAllTags(allPostTags);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog-posts' },
	    posts.map(function (_ref3) {
	      var post = _ref3.node;
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: post.frontmatter.path,
	          style: {
	            textDecoration: 'none'
	          },
	          key: post.tags + post.id
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'blog-post-preview', key: post.tags + post.id },
	          _react2.default.createElement(
	            'h1',
	            { className: 'blog-post-preview-title' },
	            post.frontmatter.title
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'blog-post-preview-date' },
	            post.frontmatter.date,
	            _react2.default.createElement(
	              'span',
	              { className: 'blog-post-tags' },
	              (0, _utils.formatPostTags)(post.frontmatter.tags)
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'blog-post-preview-excerpt' },
	            post.excerpt
	          )
	        )
	      );
	    })
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var TAG_SEPERATOR = ', ';
	
	var formatPostTags = function formatPostTags(tags) {
	  var newTags = tags.sort(function (a, b) {
	    if (a > b) return 1;
	    if (b > a) return -1;
	    return 0;
	  });
	  newTags = newTags.map(function (el) {
	    switch (el) {
	      case 'css':
	        return 'CSS';
	      case 'sass':
	        return 'SASS';
	      default:
	        return el.charAt(0).toUpperCase() + el.substring(1);
	    }
	  });
	  return newTags.join(TAG_SEPERATOR);
	};
	
	exports.default = {
	  formatPostTags: formatPostTags
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-jsx-9cdc7775df83a17c5282.js